/**
 * Application-wide constants. Anything that might reasonably change — timings,
 * limits, defaults — lives here rather than being hardcoded at call sites.
 */
export const APP_CONFIG = {
  /** Default options applied to every TanStack Query. */
  query: {
    staleTimeMs: 30_000,
    gcTimeMs: 5 * 60_000,
    retry: 2,
  },
  /** Browsers do not time out stalled WebSocket handshakes. */
  chat: {
    connectTimeoutMs: 10_000,
  },
  scenarios: {
    relativeUpdatedThresholdDays: 7,
  },
  /** Orchestration canvas defaults. */
  canvas: {
    /** Snap-to-grid step in canvas units. */
    gridSize: 16,
    nodeWidth: 264,
    /** Height assumed for a node the canvas has not measured yet. */
    nodeHeight: 128,
    /** Gap between an added node and its neighbours, on both axes. */
    addedNodeGap: 96,
    defaultAgentGap: { x: 96, y: 160 },
    /** Spacing of the background dot grid (visual only). */
    dotGap: 20,
    /** Default zoom used when opening a scenario. */
    defaultZoom: 1,
    /** Delay used to combine consecutive node drag saves. */
    layoutSaveDebounceMs: 300,
    minZoom: 0.2,
    maxZoom: 2,
    agentSearchDebounceMs: 250,
  },
  /** AI streaming behaviour. */
  ai: {
    /** Abort a stream that produces no data for this long (ms). */
    idleTimeoutMs: 30_000,
    /** Inter-token delay used by the mock generator (ms). */
    mockTokenDelayMs: 24,
  },
} as const
